import React from 'react';
import { Link } from 'react-router-dom';
export class ChanelBanner extends React.Component {
  render() {
    return (
      <div className='col-12 p-0'>
        <div className='chanelBanner'>
          <Link to='/brand/Chanel'>
            <img
              src='https://dimg.dillards.com/is/image/DillardsZoom/chanelBannerLogo_black?fmt=png-alpha&bfc=on&wid=159&hei=26&qlt=90,1&resMode=sharp2'
              alt='Chanel'
            />
          </Link>
        </div>
      </div>
    );
  }
}

export default ChanelBanner;
